module.exports = __webpack_public_path__ + "img/dcpthgz-text.41d4db9c.png";